import Button from '@restart/ui/esm/Button'
import React, { useState } from 'react'
import { Col, Container, Container as div, Row } from 'react-bootstrap'
import MyPDF from '../file/Dipta Chowdhury.pdf'


function About() {
   const [over,setOver]=useState(false);
    let buttonstyle={
        backgroundColor:''
      }
    
      if(over){
        buttonstyle.backgroundColor="green";
      }
      else{
        buttonstyle.backgroundColor='';
      }
    return (

        <div style={{backgroundColor:'#BC3C71'}}>
  <Container>
  <Row>
    <Col style={{paddingLeft: '15px'}} sm={4}><img  className="img-fluid p-2 rounded-circle  " src={require('../img/dipta.png').default} /></Col>
    <Col style={{paddingTop:'30px'}}  sm={8}>
        
        <h2>About Me</h2>
        <p>I am a junior web developer who is proficient in both back-end and front-end frameworks. My passion lies in learning about the latest technologies.</p>
        <h2>Contact Details</h2>
        
        <h4>Name: Dipta Chowdhury</h4>
        <h4>Home: 518 Terry Bazar Rd,Chattogram 4000.</h4>
        <h4>Call: +8801881890282</h4>
        <h4>Email:dip1995.bd@gmail.com</h4>
        <div className=" buttons container-fluid d-flex justify-content-center"
          style={{
            width: "320px",
            position: "relative",
            left: "-25px",
            top: "30px",
          }}></div>
        <Button variant="outline-warning"  onMouseOver={()=>setOver(true)} 
      onMouseOut={()=>setOver(false)}>
              <a 
              style={{textDecoration:'none',
              color:'#BC3C71',
               padding:'20px',
               fontSize:'25px'

               }} href={MyPDF} download="Dipta Chowdhury.pdf">My Resume </a>
              </Button>


        </Col>
  </Row>
  </Container>
</div>
    )
}

export default About
